import moment from 'moment-timezone'

function generateId() {
    return ((1e7).toString() + -1e3 + -4e3 + -8e3 + -1e11).replace(/1|0/g, () => {
        return (0 | (Math.random() * 16)).toString(16)
    })
}

function xhrData(method, param) {
    return {
        jsonrpc: '2.0',
        method,
        params: [param],
        id: generateId(),
    }
}

export class DataApiService {
    constructor($http, $q, $window) {
        'ngInject';
        this.$http = $http;
        this.$q = $q;
        this.$window = $window;

        this.CONTEXT = '/mms';
        this.RPC_URL = '/mobile/webClient';
    }

    verifyPackage(reqPromise, options = {}) {
        let showError = options.showError !== false;

        return reqPromise
            .then(res => {
                return res.data && res.data.success;
            })
            .catch(res => {
                let error = res && res.data && res.data.error || 'There was an error.';
                if (showError) {
                    this.$window.alert(error);
                }
                throw new Error(error);
            });
    }

    verifyRpcPackage(wrapper) {
        const deferred = this.$q.defer();
        if (wrapper.result.success === true) {
            deferred.resolve(wrapper.result.result);
        } else if (wrapper.result.error) {
            deferred.reject(wrapper.result.error);
            console.log(wrapper.result.error);
            this.$window.alert(wrapper.result.error);
        } else {
            deferred.reject();
        }
        return deferred.promise;
    };

    postRpc(method, payload) {
        const body = JSON.stringify(xhrData(method, payload.param));
        return this.$http.post(this.RPC_URL, body)
    }

    loginUser(email, password) {
        return this.postRpc('loginUser', { param: { email, password } }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    logoutUser() {
        return this.postRpc('logoutUser', {}).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    forgotPassword(email) {
        return this.postRpc('forgotPassword', {
            param: { email }
        }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    checkResetPasswordToken(token) {
        return this.verifyPackage(this.$http.get(`${this.CONTEXT}/web/users/resetPw/${token}`));
    }

    resetPassword(token, password) {
        return this.verifyPackage(this.$http.post(`${this.CONTEXT}/web/users/resetPw`, { token, password }));
    }

    rpcResetPassword(email, passwordToken, password) {
        return this.postRpc('passwordReset', {
            param: { email, passwordToken, password }
        }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    signupUser(user) {
        let { email, password, firstName, middleInitial, lastName, tags } = user;
        let payload = {
            email,
            password,
            firstName,
            middleInitial,
            lastName,
            tags
        };
        return this.verifyPackage(this.$http.post(`${this.CONTEXT}/web/users/sign_up`, payload))
    }

    validateNewUser(user) {
        const payload = {
            email: user.email
        };
        return this.verifyPackage(this.$http.post(`${this.CONTEXT}/web/users/validateNew`, payload))
    }

    signupPatientConnectionUser(param) {
        return this.postRpc('signupPatientConnectionUser', { param }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    getPatientConnectionUser(token) {
        return this.postRpc('getPatientConnectionUser', {
            param: { token }
        }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    getPatientConnection(token) {
        return this.postRpc('getPatientConnection', {
            param: { token }
        }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    verifyPatientConnection(token, verifyFields, confirmUser) {
        return this.postRpc('validatePatientConnection', {
            param: {
                token,
                patientDob: verifyFields.patientDob,
                patientZipCode: verifyFields.patientZipCode,
                confirmUser,
            }
        }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    addPatientConnectionProfile(token) {
        return this.postRpc('addPatientConnectionProfile', {
            param: {
                token,
            }
        }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    mergePatientConnectionProfile(token, profileId) {
        return this.postRpc('mergePatientConnectionProfile', {
            param: {
                token,
                profileId
            }
        }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    denyPatientConnection(token) {
        return this.postRpc('denyPatientConnection', {
            param: {
                token,
            }
        }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    getPatientProfiles() {
        return this.postRpc('getPatientProfiles', {
            param: {
                timezone: moment.tz.guess()
            }
        }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }

    authorizeHipaa(param) {
        return this.postRpc('authorizeHipaa', { param }).then((env) => {
            return this.verifyRpcPackage(env.data);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/dataApi.service.js